<template>
  <div>
    <NavBar msg="当日委托"></NavBar>
    <div class="content">
      <div style="background: #fff" class="todaySelected-top1">
        <div style="margin-top: 0.2rem">
          <div class="main-centent">
            <div class="todaySelected-title">
              <div style="width: 2.08rem">股票/时间</div>
              <div style="width: 1.8rem">委托/均价</div>
              <div style="width: 1.3rem">委托/成交</div>
              <div style="width: 1.65rem; text-align: right" @click="zfClick()">
                <span>状态</span>
              </div>
            </div>
          </div>
          <!-- <van-list
          v-model="loading"
          :finished="finished"
          :finished-text="more"
          @load="onLoad"
        > -->
          <van-pull-refresh v-model="isLoading" @refresh="onRefresh">
            <div class="list-main" v-if="list.length > 0">
              <van-list v-model="loading" :finished="finished" @load="onLoad">
                <div
                  class="list-item"
                  v-for="(item, index) in list"
                  :key="index"
                >
                  <div class="stock_mybody">
                    <div style="width: 2.08rem">
                      <div
                        class="top"
                        style="font-size: 0.32rem; font-weight: 500"
                      >
                        {{ item.stockName }}
                      </div>
                      <div class="bottom">
                        <div class="buy_sell">
                          <span :class="item.tradeType == 1 ? 'buy' : 'sell'">{{
                            item.tradeType == 1 ? "买" : "卖"
                          }}</span>
                          <span style="padding-top: 0.04rem">{{
                            item.orderTime
                          }}</span>
                        </div>
                      </div>
                    </div>
                    <div style="width: 1.8rem">
                      <div class="top">
                        {{ item.orderPrice }}
                      </div>
                      <div class="bottom">
                        {{ item.avgPrice }}
                      </div>
                    </div>
                    <div style="width: 1.3rem">
                      <div class="top">
                        {{ item.orderNum }}
                      </div>
                      <div class="bottom">
                        {{ item.turnoverNum }}
                      </div>
                    </div>

                    <div
                      style="
                        width: 1.65rem;
                        text-align: right;
                        font-size: 0.28rem;
                        color: #48546a;
                      "
                    >
                      <div
                        @click="chedanCliack(item.orderNo)"
                        v-if="item.state == 0 || item.state == 2"
                        class="chedan"
                      >
                        撤单
                      </div>
                      <div v-else>
                        {{
                          item.state == 1
                            ? "全部成交"
                            : item.state == 3
                            ? "全部撤单"
                            : item.state == 4
                            ? "部分成交并撤单"
                            : item.state == 5
                            ? "全部作废"
                            : "部分成交并作废"
                        }}
                      </div>
                    </div>
                  </div>
                </div>
              </van-list>
            </div>
            <div v-else class="wushuju" v-show="show">
              <img src="../assets/wushuju.png" alt="" />
              <p>暂无数据</p>
            </div>
          </van-pull-refresh>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import NavBar from "@/components/NavBar.vue";

import api from "@/api/index";
import { Tab, Tabs, Toast, List, PullRefresh } from "vant";
export default {
  components: {
    NavBar,
    [Tab.name]: Tab,
    [Tabs.name]: Tabs,
    [Toast.name]: Toast,
    [List.name]: List,
    [PullRefresh.name]: PullRefresh,
  },
  data() {
    return {
      active: 0,
      list: [],
      userId: "",
      show: false,
      page: 1,
      loading: false,
      finished: true,
      refreshing: false,
      isLoading: false,
      total: "",
      upLoadClicktag: 0,
    };
  },
  created() {
    this.userId = localStorage.getItem("userId");

    this.getList();
  },
  methods: {
    onRefresh() {
      setTimeout(() => {
        this.isLoading = false;
        this.page = 1;
        this.list = [];
        this.getList();
      }, 1000);
    },
    onLoad() {
      // 异步更新数据
      // setTimeout 仅做示例，真实场景中一般为 ajax 请求
      setTimeout(() => {
        this.page++;
        // 加载状态结束
        // console.log(this.page);
        this.loading = false;
        this.getList();
        // 数据全部加载完成
      }, 1000);
    },
    // goJRCJ() {
    //   this.$router.push({ path: "/jrcj" });
    // },
    // goJRWT() {
    //   this.$router.push({ path: "/jrwt" });
    // },
    // goLSCJ() {
    //   this.$router.push({ path: "/lscj" });
    // },
    // goLSWT() {
    //   this.$router.push({ path: "/lswt" });
    // },
    chedanCliack(orderNo) {
      if (this.upLoadClicktag == 0) {
        //改版变量
        this.upLoadClicktag = 1;
        api.getWitorder({ orderNo: orderNo }).then((res) => {
          // console.log(res);
          if (res.code == 200) {
            // item.tradeType=5
            Toast("撤单成功");
            this.page = 1;
            this.list = [];
            this.getList();
          }
        });
      }
    },
    getList() {
      let params = {
        analog_stock_account_id: this.userId,
        type: 1,
        page: this.page,
        pageSize: 20,
      };
      api.getOrderList(params).then((res) => {
        // console.log(res);
        if (res.code == 200) {
          var list = [];
          list = res.data.records;
          this.total = res.data.total;
          this.list = this.list.concat(list);

          if (this.list.length >= this.total) {
            this.finished = true;
          } else {
            this.finished = false;
          }
          setTimeout(() => {
            this.upLoadClicktag = 0;
          }, 200);

          if (this.list.length > 0) {
            this.show = false;
          } else {
            this.show = true;
          }
        }
      });
    },
  },
};
</script>

<style lang="less" scoped>
.list-main {
  padding-bottom: 2rem;
  background: #f5f5f5;
}
.list-item {
  background: #fff;
}
.content {
  height: 100vh;
  // overflow: hidden;
  background: #f5f5f5;
  padding-top: 0.87rem;
}
.main-centent {
  padding: 0 0 0 0.32rem;
  border-bottom: 0.01rem solid rgba(237, 237, 237, 1);
}
.todaySelected-top {
  height: 0.5rem;
  font-size: 0.36rem;
  font-weight: bold;
  color: #333333;
  line-height: 0.5rem;
}
.todaySelected-title {
  height: 0.76rem;
  color: #666666;
  //   margin: 0 0 0 0.32rem;
  font-size: 0.24rem;

  display: flex;
  justify-content: initial;
  align-items: center;

  div:nth-child(4) {
    display: flex;
    justify-content: flex-end;
    align-items: center;
    img {
      width: 0.44rem;
      height: 0.44rem;
    }
  }
}
.stock_mybody {
  height: 1.2rem;
  display: flex;
  /* justify-content: space-between; */
  align-items: center;
  padding: 0 0.32rem;
  font-size: 0.3rem;
  border-bottom: 0.01rem solid #e8e8e8;
}
.stock_mybody .van-collapse-item {
  padding: 0 0 0 0 !important;
}
.bottom {
  font-size: 0.28rem;
  color: #999999;
}
.top {
  color: #333333;
  font-size: 0.36rem;
  line-height: 0.5rem;
}
.chedan {
  width: 0.8rem;
  height: 0.4rem;
  border-radius: 0.04rem;
  border: 1px solid #48546a;
  text-align: center;
  float: right;
  font-size: 0.28rem;
  font-family: PingFang-SC-Regular, PingFang-SC;
  font-weight: 400;
  color: #48546a;
  display: flex;
  align-items: center;
  justify-content: center;
}
.buy_sell {
  display: flex;
  align-items: center;
}
.buy {
  font-size: 0.2rem;
  width: 0.28rem;
  height: 0.28rem;
  background: #e5464d;
  margin-right: 0.04rem;
  color: #fff;
  display: flex;
  align-items: center;
  justify-content: center;
}
.sell {
  font-size: 0.2rem;
  width: 0.28rem;
  height: 0.28rem;
  background: #5187d4;
  margin-right: 0.04rem;
  color: #fff;
  display: flex;
  align-items: center;
  justify-content: center;
}
.wushuju {
  height: 4rem;
  background: #f5f5f5;
  display: flex;
  flex-direction: column;
  align-items: center;
  padding-top: 1.7rem;
  img {
    height: 4rem;
    width: 4rem;
  }
}
</style>